import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/Logo";
import { InstallAppButton } from "@/components/InstallAppButton";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Error de inicio de sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-jungle flex items-center justify-center px-6 grain relative">
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo variant="light" />
        </div>
        <form onSubmit={submit} className="bg-sand p-8 border border-border" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={18} className="text-teal" />
            <h1 className="font-heading text-2xl font-semibold text-jungle">Panel de administración</h1>
          </div>
          <label className="font-body text-xs uppercase tracking-wider text-jungle-light/70 mb-1.5 block">Correo</label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white rounded-none border-border mb-4" placeholder="admin@xctmexico.com" />
          <label className="font-body text-xs uppercase tracking-wider text-jungle-light/70 mb-1.5 block">Contraseña</label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white rounded-none border-border mb-5" placeholder="••••••••" />
          {error && <p className="font-body text-sm text-red-600 mb-4" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full inline-flex items-center justify-center gap-2 bg-teal text-sand hover:bg-teal-dark font-body py-3.5 transition-colors disabled:opacity-60">
            {loading && <Loader2 size={18} className="animate-spin" />}
            Entrar
          </button>
        </form>
        <InstallAppButton className="mt-4" />
      </div>
    </div>
  );
}
